import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {CodaltComponent} from '../codalt.component';
import {Routenames} from '../route-names.enum';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {DeclarationType} from '../declaration-type';
import {DeclarationService} from '../services/declaration.service';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {CurrencyPipe} from "@angular/common";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'app-declaration-management',
    templateUrl: './declaration-management.component.html',
    styleUrls: ['./declaration-management.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        CurrencyPipe,
        MatIconButton
    ]
})
export class DeclarationManagementComponent extends CodaltComponent implements OnInit, OnDestroy {

    readonly types = signal<DeclarationType[]>([]);
    currentSort = null;
    desc = false;

    constructor(
        private declarationService: DeclarationService,
        private confirmDialog: ConfirmDialogService,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(this.declarationService.listType().subscribe(equipment => {
            this.types.set(equipment.data);
        }));
    }

    edit(type: DeclarationType) {
        this.router.navigate([Routenames.declarationTypes, type.id]);
    }

    sortList(sortingOn) {
        let decorations = this.types();
        this.types.set([]);

        if (sortingOn === this.currentSort) {
            decorations = decorations.reverse();
            this.desc = !this.desc;
        } else {
            this.desc = false;
            decorations = decorations.sort((a, b) => {
                if (a[sortingOn].toUpperCase() < b[sortingOn].toUpperCase()) {
                    return -1;
                }
                if (a[sortingOn].toUpperCase() > b[sortingOn].toUpperCase()) {
                    return 1;
                }
                return 0;
            });
        }

        this.types.set(decorations);

        this.currentSort = sortingOn;
    }

    delete(event, type: DeclarationType) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Aanvraag intrekken',
            `Weet u zeker dat u declaratie type ${type.name} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.subscriptions.add(this.declarationService.deleteType(type.id).subscribe(() => {
                const index = this.types().indexOf(type);
                this.types().splice(index, 1);
            }));
        }, () => {

        });
    }


    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
